
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/neet-college-predictor",
      function () {
        return require("private-next-pages/neet-college-predictor.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/neet-college-predictor"])
      });
    }
  